import { ApiResponse } from "../../../types/api.types";
import axiosClient from "../../../utils/axios";
import { ReportListRequest, ReportListResponse, SurveyScoresApiResponse } from "../types/individualReport.types";

/**
 * Radar Scores
 */

export const getSurveyScores = async (questionnaire_id: number) => {
  try {
    const response = await axiosClient.post<SurveyScoresApiResponse>(
      "/survey/scores",
      { questionnaire_id }
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching survey scores:", err);
    throw err;
  }
};

/**
 * Report List
 */

export const getReportList = async (params?: ReportListRequest) => {
  try {
    const response = await axiosClient.post<ApiResponse<ReportListResponse>>(
      "/report/list",
      {
        page: params?.page ?? 1,
        limit: params?.limit ?? 10,
        search: params?.search ?? "",
      }
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching report list: ", err);
    throw err;
  }
};
